
export default {
  getHomeData: '/gateway/capp/ActivityForAppRpcService/getPartnerActivityDetail',
  getAwardData: '/gateway/capp/ActivityForAppRpcService/lottery',
  getShareData: '/gateway/capp/ActivityForAppRpcService/partnerActivitySettleShare'
}
